import { render, staticRenderFns } from "./ShopUpdatePlatformDialog.vue?vue&type=template&id=97a6a920&scoped=true&lang=pug&"
import script from "./ShopUpdatePlatformDialog.vue?vue&type=script&lang=ts&"
export * from "./ShopUpdatePlatformDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a6a920",
  null
  
)

export default component.exports